import {sendDataLayer} from "../../util/tagmanager";

export const handleTagManager = ({
    track_id,
    track_name,
    DROPDOWN1_TYPES,
    filter1Selected,
    selectedVideos,
    selectedSpeakers,
    selectedTopics,
    filter3Selected,
    contextSelector,
    oldSelection,
    setOldSelection,
}) => {
    let namesArray = [];
    let idsArray = [];

    if (selectedVideos && selectedVideos.length) {
        namesArray = selectedVideos.map(video => video.name);
        idsArray = selectedVideos.map(video => video.id);
    } else if (selectedSpeakers && selectedSpeakers.length) {
        namesArray = selectedSpeakers.map(speaker => speaker.name);
        idsArray = selectedSpeakers.map(speaker => speaker.id);
    } else if (selectedTopics && selectedTopics.length) {
        namesArray = selectedTopics.map(topic => topic.name);
        idsArray = selectedTopics.map(topic => topic.id);
    }

    const selection_type = filter1Selected?.[0]?.id;
    const selection_ids = idsArray;
    const selected_insight = filter3Selected?.[0];
    const filter1IsVideo = selection_type === DROPDOWN1_TYPES.videos.id;
    const filter1IsHighlights = selection_type === DROPDOWN1_TYPES.highlights.id;
    const filter1IsTopics = selection_type === DROPDOWN1_TYPES.topics.id;
    const filter1IsSpeakers = selection_type === DROPDOWN1_TYPES.speakers.id;

    if (
        (filter1IsTopics && selectedTopics.length) ||
        (filter1IsVideo && selectedVideos.length && selected_insight) ||
        (filter1IsSpeakers && selectedSpeakers.length && selected_insight) ||
        filter1IsHighlights
    ) {
        let currentSelection = {selection_type, selection_ids, selected_insight};
        let dataLayerContent = {
            track_id,
            track_name,
            event: "track_netgraph_filter",
        };

        if (
            track_name &&
            (JSON.stringify(oldSelection.selection_type) !== JSON.stringify(selection_type) ||
                JSON.stringify(oldSelection.selection_ids) !== JSON.stringify(selection_ids) ||
                JSON.stringify(oldSelection.selected_insight) !== JSON.stringify(selected_insight))
        ) {
            //diferencias de type
            const type_differences = {from: oldSelection.selection_type, to: selection_type};
            dataLayerContent.selection_type = JSON.stringify(type_differences);

            //diferencias de ids
            const ids_differences = {from: oldSelection.selection_ids, to: selection_ids};
            dataLayerContent.selection_ids = JSON.stringify(ids_differences);

            //diferencias de insights
            dataLayerContent.selection_insight = JSON.stringify({
                from: oldSelection.selected_insight?.key,
                to: selected_insight?.key,
            });

            sendDataLayer(dataLayerContent, {context: contextSelector});
            setOldSelection(currentSelection);
        }
    }
};

export const getNetgraphType = (DROPDOWN1_TYPES, type) => {
    if (type === DROPDOWN1_TYPES.topics.id) return 1;
    else if (type === DROPDOWN1_TYPES.videos.id) return 2;
    else if (type === DROPDOWN1_TYPES.speakers.id) return 3;
    else if (type === DROPDOWN1_TYPES.highlights.id) return 1;
};

export const getItemsSelectorModalData = (
    DROPDOWN1_TYPES,
    filter1Selected,
    videosOptions,
    selectedVideos,
    setSelectedVideos,
    speakersOptions,
    selectedSpeakers,
    setSelectedSpeakers,
    topicsOptions,
    selectedTopics,
    setSelectedTopics
) => {
    const filter1SelectedName = filter1Selected?.[0]?.name;
    const typeToLowerCase = filter1SelectedName?.toLowerCase();
    let obj = {
        type: filter1SelectedName,
        allItems: [],
        selectedItems: [],
        setSelectedItems: () => {},
    };

    if (typeToLowerCase) {
        if (typeToLowerCase === DROPDOWN1_TYPES.videos.id) {
            obj.allItems = videosOptions;
            obj.selectedItems = selectedVideos;
            obj.setSelectedItems = setSelectedVideos;
        } else if (typeToLowerCase === DROPDOWN1_TYPES.speakers.id) {
            obj.allItems = speakersOptions;

            obj.selectedItems = selectedSpeakers;
            obj.setSelectedItems = setSelectedSpeakers;
        } else if (typeToLowerCase === DROPDOWN1_TYPES.topics.id) {
            obj.allItems = topicsOptions;

            obj.selectedItems = selectedTopics;
            obj.setSelectedItems = setSelectedTopics;
        }
    }

    return obj;
};
